<h1>Post Processing</h1>
<mat-divider></mat-divider>
<p>
    Once all the applications have been completed,
    you can use this page to download an Excel spreadsheet of all the completed applications.
    You can use this spreadsheet to add family income and disqualify some students.
    You can download the report with the button below.
    If you fill in the specified info in the spreadsheet and upload it back here,
    the info will be added to the system.
</p>
<p>
    To add family income, input the value in the "Family Income" column in the row with the student info.
    This has a character length of 50.
</p>
<p>
    To disqualify a student, type "disqualify" in the "Disqualify This Student" column
    and write a reason why in the "Disqualification Reason" column in the row with the student info.
    The disqualification reason has a character length of 50.
</p>

<button mat-raised-button (click)="download()">Download Completed Applications</button>

<div class="my-[50px]">
    <mat-form-field appearance="outline" class="w-[400px]">
        <input matInput type="text" readonly placeholder="{{selectedFile?.name}}" />
        <mat-hint>
            @if (fileTypeInvalid === true) {
            <span class="text-red-500">File type invalid. </span>
            }
            File must end in .xlsx
        </mat-hint>
    </mat-form-field>
    <input #fileUpload hidden type="file" (change)="selectFile($event)" />
    <button class="mx-[20px]" mat-raised-button (click)="fileUpload.click()">Choose File</button>
    <button mat-flat-button (click)="upload()" [disabled]="selectedFile == null">Upload</button>
</div>

@if (report != null) {
<mat-card>
    <mat-card-header>
        <mat-card-title>Upload Report</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="my-[20px]">
            <div class="flex justify-between w-[250px]">
                <span>Family Income Updated: </span>
                <strong>{{report.SuccessfulFamilyRows}}</strong>
            </div>
            <div class="flex justify-between w-[250px]">
                <span>Students Disqualified: </span>
                <strong>{{report.SuccessfulDisqualifyRows}}</strong>
            </div>
            <div class="flex justify-between w-[250px]">
                <span>Students With No Changes: </span>
                <strong>{{report.NoChangeRows}}</strong>
            </div>
        </div>
        <mat-card-title>Warnings:</mat-card-title>
        @if (report.Warnings == null || report.Warnings.length === 0) {
        <p>None</p>
        }
        <ul>
            @for (w of report.Warnings; track w) {
            <li>
                Row {{w.RowNumber}}: {{w.Message}}
            </li>
            }
        </ul>
        <mat-card-title>Errors:</mat-card-title>
        @if (report.Errors == null || report.Errors.length === 0) {
        <p>None</p>
        }
        <ul>
            @for (e of report.Errors; track e) {
            <li>
                Row {{e.RowNumber}}: {{e.Message}}
            </li>
            }
        </ul>
    </mat-card-content>
</mat-card>
}